import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import Button from '@techsoftware/happay-widgets/Button';
import Success from '../../assets/images/success.svg';
import Failure from '../../assets/images/failure.svg';
import history from '../../utils/history';
import PropTypes from 'prop-types';

export default function SubmitBulkVendors(props) {
  const { stepStatus, initStates } = props;
  const handleVendorRedirection = () => {
    initStates();
    history.push(`/vendor/myvendor?tab=Saved`);
  };
  return (
    <Grid item container xs={24} sm={24} md={24} lg={24} xl={24}>
      <Grid
        container
        xs={24}
        sm={24}
        md={24}
        lg={24}
        xl={24}
        className={`white-bg`}
      >
        <Grid
          item
          xs={24}
          sm={24}
          md={24}
          lg={24}
          xl={24}
          className=" white-bg fw-500 font-14 dark-blue-grey flex-d-column d-flex align-item-baseline-imp overflow-auto"
        >
          <Grid
            item
            className="flex-horizontal-center flex-vertical-center width-100 margin-b-24"
          >
            <img src={stepStatus === 'failure' ? Failure : Success} />
          </Grid>
          <Grid className="flex-horizontal-center flex-vertical-center width-100 font-20 fw-600 margin-b-16">
            {stepStatus == 'success'
              ? 'Vendors submitted successfully'
              : 'Vendor submission Failure'}
            !
          </Grid>
          <Grid
            container
            direction={'column'}
            className="flex-horizontal-center flex-vertical-center width-100 "
          >
            {stepStatus == 'success' ? (
              <div className="text-center-align light-black fw-400 width-27">
                You have successfully submitted the Vendors and will receive a
                <span className="fw-500"> Confirmation Email</span> once the
                Vendor creation process is completed.
              </div>
            ) : (
              <div className="text-center-align light-black fw-400 width-27">
                An error has incurred while submitting the vendors, please try
                again or reach out to us on our Customer Care.
              </div>
            )}
            <Button
              type="button"
              text={'My Vendors'}
              variant="primary"
              size="medium"
              onClick={handleVendorRedirection}
              className={'margin-tb-36'}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

SubmitBulkVendors.propTypes = {
  stepStatus: PropTypes.string,
};

SubmitBulkVendors.defaultProps = {
  stepStatus: '',
};
